import { sendGTMEvent } from '@next/third-parties/google';
export interface GTMDisplayInterface {
  siteName: string | 'TechTargetHub';
  //AdblockEnabled: boolean | false;
  appCode?: string | "151";
  contentID?: string;
  contentType?: string;
  pageType?: string;
  memberStatus?: string;
  siteClass: string | 'TechTargetHub';
  accessStatus?: string; // how content accessed - fastpass | passwordless | registration non member
  assetType?: string; //sponsored/unsponsored  PE Demand
  orgID?: string;
  orgName?: string;
}
export interface GTMClickInterface {
  click_element?: string | '';
  click_target?: string | '';
  click_closest_class?: string | '';
  click_section_ID?: string | '';
  link_classes?: string | '';
  link_id?: string | '';
  link_text?: string | null | undefined;
  link_url?: string | '';
  click_category?: string | '';
  click_destination?: string | '';
  click_closest_href?: string | '';
}
const defaultGTMDisplay: GTMDisplayInterface = {
  siteName: 'TechTargetHub',
  // passed as a default as site name doesn't change for CH
  siteClass: 'TechTargetHub' // passed as a default doesn't change for CG pages
};
export const pushGTMDisplayTags = (tags: Partial<GTMDisplayInterface>) => {
  const finaltags = {
    ...defaultGTMDisplay,
    ...tags
  };
  for (const [key, value] of Object.entries(finaltags)) {
    if (value) {
      sendGTMEvent({
        event: 'display_tt',
        value: {
          display_category: key,
          display_action: value
        }
      });
    }
  }
};
export const pushGTMClickTags = (tags: Partial<GTMClickInterface>) => {
  const finaltags = {
    ...defaultGTMDisplay,
    ...tags
  };
  for (const [key, value] of Object.entries(finaltags)) {
    if (value) {
      sendGTMEvent({
        event: 'click_tt',
        value: {
          click_category: key,
          display_action: value
        }
      });
    }
  }
};